let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6gnFj"), load("ehUbM"), load("5w3tp"), load("aDgIB")]).then(() => parcelRequire('3K1px'));